import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  LayoutDashboard,
  Users,
  FileText,
  Settings,
  TrendingUp,
  MessageSquare,
  Database,
  Share2,
  DollarSign,
  Shield,
  ArrowLeft,
} from 'lucide-react';

interface NavItem {
  name: string;
  href: string;
  icon: React.ElementType;
}

interface GroupManagementNavProps {
  groupId: string;
}

export const GroupManagementNav: React.FC<GroupManagementNavProps> = ({ groupId }) => {
  const location = useLocation();

  const navigation: NavItem[] = [
    {
      name: 'Dashboard',
      href: `/groups/${groupId}/dashboard`,
      icon: LayoutDashboard,
    },
    {
      name: 'Clinicians',
      href: `/groups/${groupId}/clinicians`,
      icon: Users,
    },
    {
      name: 'Analytics',
      href: `/groups/${groupId}/analytics`,
      icon: TrendingUp,
    },
    {
      name: 'Matchmaking',
      href: `/groups/${groupId}/matchmaking`,
      icon: MessageSquare,
    },
    {
      name: 'Advertise',
      href: `/groups/${groupId}/advertise`,
      icon: DollarSign,
    },
    {
      name: 'Blog',
      href: `/groups/${groupId}/blog`,
      icon: FileText,
    },
    {
      name: 'Integrations',
      href: `/groups/${groupId}/integrations`,
      icon: Database,
    },
    {
      name: 'Referrals',
      href: `/groups/${groupId}/referrals`,
      icon: Share2,
    },
    {
      name: 'Settings',
      href: `/groups/${groupId}/settings`,
      icon: Settings,
    },
  ];

  return (
    <div className="bg-white shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex-shrink-0">
            <Link
              to="/groups"
              className="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
            >
              <ArrowLeft className="h-4 w-4 mr-2" />
              Back
            </Link>
          </div>
          <nav className="flex space-x-8">
            {navigation.map((item) => {
              const Icon = item.icon;
              const isActive = location.pathname === item.href;

              return (
                <Link
                  key={item.name}
                  to={item.href}
                  className={`inline-flex items-center px-1 pt-1 text-sm font-medium border-b-2 ${
                    isActive
                      ? 'border-purple-500 text-gray-900'
                      : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
                  }`}
                >
                  <Icon className="h-5 w-5 mr-2" />
                  {item.name}
                </Link>
              );
            })}
          </nav>
        </div>
      </div>
    </div>
  );
};